import styled from 'styled-components'
import { Box } from 'uikit'
import Container from '../Layout/Container'
import { PageHeaderProps } from './types'
  // background: ${({ theme, background }) => background || theme.colors.gradients.bubblegum};
  // background-image: url(/images/panner.png);
const Outer = styled(Box)<{ background?: string }>`

  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  margin-top:16px;
  background-image: url(/images/panner2.png);
  ${({ theme }) => theme.mediaQueries.lg} {
    background-image: url(/images/banner2.png);
  }

  ${({ background }) => background} {
    background-image: url(/images/panner.png);
    ${({ theme }) => theme.mediaQueries.lg} {
      background-image: url(/images/banner.png);
      }
  }
.mint{
  padding-top: 32px;
  padding-bottom: 32px;
  margin-bottom:32px;
}

`

const Inner = styled(Container)`
  padding-top: 32px;
  padding-bottom: 32px;
  margin-bottom:32px;
`

const PageHeader: React.FC<PageHeaderProps> = ({ background, children, ...props }) => (
  <Outer background={background} {...props}>
    <Inner>{children}</Inner>
  </Outer>
)

export default PageHeader
